import { request as sonataRequest } from 'sonata-react-components';

export const getPermissions = (hostURL?: string): Promise<Record<string, any>[]> => {
  const urlBase = hostURL ?? taptap.config.sonataBackendUrl;

  return sonataRequest.makeRequest(`${urlBase}permissions`, {
    method: 'GET'
  });
};
